<template>
  <div>
    <modal
        name="logosEdit"
        height="auto"
        width="900"
        :scrollable="true"
        :clickToClose="false"
    >
      <CloseModal :close="close"/>
      <div class="modalbox">
        <div class="modalbox-content">
          <CTabs variant="tabs" class="nav-tabs-boxed">
            <CTab :title="`Salvando ${descSingular}`">
              <h6 class="section-label">Informações</h6>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-label">Descrição</label>
                    <input class="form-control" v-model="item.descricao" maxlength="255"/>
                    <div class="message">
                      {{ validation.firstError("item.descricao") }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-label">Link</label>
                    <input class="form-control" v-model="item.link"/>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="form-label">Ordem</label>
                    <input
                        type="number"
                        class="form-control"
                        v-model="item.ordem"
                    />
                    <div class="message">
                      {{ validation.firstError("item.ordem") }}
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="form-label">Tipo</label>
                    <select class="form-control" v-model="item.tipo_id">
                      <option
                          v-for="logoTipo in logosTipo"
                          v-bind:key="logoTipo.chave"
                          :value="logoTipo.id"
                      >
                        {{ logoTipo.tipo }}
                      </option>
                    </select>
                    <div class="message">
                      {{ validation.firstError("item.tipo_id") }}
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="form-label">Ativo</label>
                    <select class="form-control" v-model="item.ativo">
                      <option value="1">Sim</option>
                      <option value="0">Não</option>
                    </select>
                    <div class="message">
                      {{ validation.firstError("item.ativo") }}
                    </div>
                  </div>
                </div>
                <div v-if="isTipoSeguranca" class="col-md-3">
                  <div class="form-group">
                    <label class="form-label">Conteúdo</label>
                    <select v-model="item.conteudo_tipo" class="form-control" v-on:change="resetFields">
                      <option value="HTML">Html</option>
                      <option value="IMAGEM">Imagem</option>
                    </select>
                  </div>
                </div>
              </div>

              <h6 class="section-label">Conteúdo</h6>
              <div v-if="isTipoSlotHome" class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="form-label">Tipo de conteúdo</label>
                    <select class="form-control" v-model="item.conteudo_tipo">
                      <option value="imagem">Imagem</option>
                      <option value="texto">Bloco de texto</option>
                    </select>
                  </div>
                </div>
              </div>

              <div v-if="isConteudoHtml && isTipoSeguranca" class="row">
                <div class="col-12">
                  <div class="form-group">
                    <editor-conteudo :item="item"></editor-conteudo>
                  </div>
                </div>
              </div>

              <template v-if="isBlocoTexto">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label">Título</label>
                      <input
                          class="form-control"
                          v-model="item.titulo"
                          maxlength="255"
                          placeholder="Ex.: Orçamento para escolas"
                      />
                      <div class="message">
                        {{ validation.firstError("item.titulo") }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label">Subtítulo</label>
                      <input
                          class="form-control"
                          v-model="item.subtitulo"
                          maxlength="255"
                          placeholder="Ex.: Condições especiais para instituições"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-8">
                    <div class="form-group">
                      <label class="form-label">Resumo</label>
                      <textarea
                          class="form-control"
                          v-model="item.resumo"
                          rows="5"
                          maxlength="2000"
                          placeholder="Texto curto de apoio exibido no bloco"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-md-4 add-image">
                    <label>
                      <image-picker
                          label="Imagem do bloco (opcional)"
                          placeholder="Colar URL ou clique ao lado para upload"
                          v-model="item.imagem_fundo"
                      />
                    </label>
                  </div>
                </div>
              </template>

              <div v-if="exibeCamposImagem" class="row">
                <div class="col-md-4 add-image">
                  <label>
                    <image-picker
                        label="Adicionar Imagem Desktop"
                        placeholder="Colar URL ou clique ao lado para upload"
                        v-model="item.imagem"
                    />
                  </label>
                  <div class="message">
                    {{ validation.firstError("item.imagem") }}
                  </div>
                </div>
                <div class="col-md-4 add-image">
                  <label>
                    <image-picker
                        label="Adicionar Imagem Mobile"
                        placeholder="Colar URL ou clique ao lado para upload"
                        v-model="item.imagem_mobile"
                    />
                  </label>
                  <div class="message">
                    {{ validation.firstError("item.imagem_mobile") }}
                  </div>
                </div>
              </div>

              <div v-if="isTipoSlotHome && !isBlocoTexto" class="row">
                <div class="col-12">
                  <CAlert color="warning" v-bind:visible="true">
                    <CAlertHeading>
                      <h5>
                        <CIcon name="cil-warning"/>
                        Medidas padrões para melhor
                        exibição:
                      </h5>
                    </CAlertHeading>
                    <p>
                      <CIcon name="cil-screen-desktop"/>
                      Pequeno: 270 x 220
                      pixels, Médio: 560 x 220 pixels, Grande: 1140 x 220 pixels
                    </p>
                    <p>
                      <CIcon name="cil-screen-smartphone"/>
                      Pequeno: 160 x 130
                      pixels, Grande: 320 x 130 pixels
                    </p>
                  </CAlert>
                </div>
              </div>

              <template v-if="isTipoSlotHome">
                <h6 class="section-label">Larguras</h6>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="form-label">Largura Ocupada (Desktop)</label>
                      <select class="form-control" v-model="item.largura">
                        <option
                            v-for="opcaoLargura in opcoesLargura"
                            :key="`largura-${opcaoLargura.valor}`"
                            :value="opcaoLargura.valor"
                        >
                          {{ opcaoLargura.texto }}
                        </option>
                      </select>
                      <div class="message">
                        {{ validation.firstError("item.largura") }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="form-label">Largura Ocupada (Tablet)</label>
                      <select class="form-control" v-model="item.largura_tablet">
                        <option :value="null">Automático (igual ao desktop)</option>
                        <option
                            v-for="opcaoLargura in opcoesLargura"
                            :key="`largura-tablet-${opcaoLargura.valor}`"
                            :value="opcaoLargura.valor"
                        >
                          {{ opcaoLargura.texto }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="form-label">Largura Ocupada (Mobile)</label>
                      <select class="form-control" v-model="item.largura_mobile">
                        <option :value="null">Automático</option>
                        <option
                            v-for="opcaoLargura in opcoesLargura"
                            :key="`largura-mobile-${opcaoLargura.valor}`"
                            :value="opcaoLargura.valor"
                        >
                          {{ opcaoLargura.texto }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </template>

              <template v-if="isTipoSlotHome && item.estilo">
                <h6 class="section-label">Aparência</h6>
                <template v-if="isBlocoTexto">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="form-label">Fundo do bloco</label>
                        <select class="form-control" v-model="item.estilo.fundo_tipo">
                          <option value="nenhum">Nenhum (transparente)</option>
                          <option value="solido">Cor sólida</option>
                          <option value="gradiente">Gradiente (2 cores)</option>
                        </select>
                      </div>
                    </div>
                    <div v-if="item.estilo.fundo_tipo !== 'nenhum'" class="col-md-4">
                      <div class="form-group">
                        <label class="form-label">
                          {{ item.estilo.fundo_tipo === 'gradiente' ? 'Cor inicial' : 'Cor de fundo' }}
                        </label>
                        <ColorInput v-model="item.estilo.cor_fundo"/>
                      </div>
                    </div>
                    <div v-if="item.estilo.fundo_tipo === 'gradiente'" class="col-md-4">
                      <div class="form-group">
                        <label class="form-label">Cor final</label>
                        <ColorInput v-model="item.estilo.cor_fundo_final"/>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="form-label">Posição da imagem no bloco</label>
                        <select class="form-control" v-model="item.estilo.posicao_imagem">
                          <option value="fundo">Fundo (atrás do texto)</option>
                          <option value="esquerda">Esquerda</option>
                          <option value="direita">Direita</option>
                          <option value="cima">Cima</option>
                          <option value="baixo">Baixo</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="form-label">Alinhamento do texto</label>
                        <select class="form-control" v-model="item.estilo.alinhamento_texto">
                          <option value="esquerda">Esquerda</option>
                          <option value="centro">Centro</option>
                          <option value="direita">Direita</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="form-label">Tamanho do texto</label>
                        <select class="form-control" v-model="item.estilo.tamanho_texto">
                          <option value="pequeno">Pequeno (compacto)</option>
                          <option value="medio">Médio (padrão)</option>
                          <option value="grande">Grande (destaque)</option>
                          <option value="gigante">Gigante (hero)</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="form-label">Texto do botão de ação (opcional)</label>
                        <input
                            class="form-control"
                            v-model="item.estilo.cta_texto"
                            maxlength="80"
                            placeholder="Ex.: FAÇA SEU ORÇAMENTO (vazio = sem botão)"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label class="form-label">Fundo do botão</label>
                        <ColorInput v-model="item.estilo.cta_cor_fundo"/>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label class="form-label">Texto do botão</label>
                        <ColorInput v-model="item.estilo.cta_cor_texto"/>
                      </div>
                    </div>
                  </div>
                </template>

                <div class="form-group">
                  <label class="form-label">Acabamento</label>
                  <div class="toggle-row">
                    <label class="toggle-item" :class="{ active: item.estilo.cantos_arredondados }">
                      <input type="checkbox" v-model="item.estilo.cantos_arredondados"/>
                      Cantos arredondados
                    </label>
                    <label class="toggle-item" :class="{ active: item.estilo.usa_borda }">
                      <input type="checkbox" v-model="item.estilo.usa_borda"/>
                      Borda
                    </label>
                    <label
                        class="toggle-item"
                        :class="{ active: item.estilo.largura_total }"
                        title="O bloco ignora o container e ocupa 100% da largura da página"
                    >
                      <input type="checkbox" v-model="item.estilo.largura_total"/>
                      Largura total da página
                    </label>
                  </div>
                </div>
                <div v-if="item.estilo.usa_borda" class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="form-label">Cor da borda</label>
                      <ColorInput v-model="item.estilo.cor_borda"/>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="form-label">Espessura da borda</label>
                      <select class="form-control" v-model="item.estilo.espessura_borda">
                        <option
                            v-for="espessura in 6"
                            :key="`espessura-${espessura}`"
                            :value="espessura"
                        >
                          {{ espessura }}px
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </template>

              <h6 class="section-label">Exibição</h6>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="form-label">VersoCommerce</label>
                    <select class="form-control" v-model="item.acesso_site">
                      <option value="1">Sim</option>
                      <option value="0">Não</option>
                    </select>
                    <div class="message">
                      {{ validation.firstError("item.acesso_site") }}
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="form-label">VersoApp</label>
                    <select class="form-control" v-model="item.acesso_app">
                      <option value="1">Sim</option>
                      <option value="0">Não</option>
                    </select>
                    <div class="message">
                      {{ validation.firstError("item.acesso_app") }}
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="form-label">(VersoApp)Modo Cliente Final</label>
                    <select
                        class="form-control"
                        v-model="item.acesso_cliente_final"
                    >
                      <option value="1">Sim</option>
                      <option value="0">Não</option>
                    </select>
                    <div class="message">
                      {{ validation.firstError("item.acesso_cliente_final") }}
                    </div>
                  </div>
                </div>
              </div>
            </CTab>
          </CTabs>
        </div>
      </div>
      <div class="modal-footer-bar">
        <CButton variant="outline" color="secondary" @click="close">
          Fechar
        </CButton>
        <CButton
            color="primary"
            :disabled="validation.hasError()"
            @click="handleSubmit"
        >
          Salvar
        </CButton>
      </div>
    </modal>
  </div>
</template>

<script>
import {Validator} from "simple-vue-validator";
import CloseModal from "../../../components/CloseModal";
import ColorInput from "../../../components/ColorInput";
import ImagePicker from "../../../components/ImagePicker";
import EditorConteudo from "../../../components/EditorConteudo.vue";
import {
  conteudoTipoNormalizado,
  ehBlocoTexto,
  ehConteudoHtml,
  ehTipoSeguranca,
  ehTipoSlotHome,
  exibeCamposImagem,
  imagensObrigatorias,
  tituloObrigatorio,
} from "../helpers/blocoConteudo";

export default {
  customToolbar: [
    [{header: [false, 1, 2, 3, 4, 5, 6]}],
    ["bold", "italic", "underline", "strike"],
    [
      {align: ""},
      {align: "center"},
      {align: "right"},
      {align: "justify"},
    ],
    ["blockquote", "code-block"],
    [{list: "ordered"}, {list: "bullet"}, {list: "check"}],
    [{indent: "-1"}, {indent: "+1"}],
    [{color: []}, {background: []}],
    ["link", "image", "video", "code"],
    ["clean"],
  ],
  name: "logosEdit",
  props: ["item", "update", "close", "modulos", "descSingular", "logosTipo"],
  components: {EditorConteudo, CloseModal, ColorInput, ImagePicker},
  data() {
    return {
      opcoesLargura: [
        {valor: 12, texto: "100% (1 por linha)"},
        {valor: 8, texto: "66% (2/3 da linha)"},
        {valor: 6, texto: "50% (2 por linha)"},
        {valor: 4, texto: "33% (3 por linha)"},
        {valor: 3, texto: "25% (4 por linha)"},
        {valor: 2, texto: "16% (6 por linha)"},
      ],
    };
  },
  computed: {
    isTipoSeguranca() {
      return ehTipoSeguranca(this.item);
    },
    isTipoSlotHome() {
      return ehTipoSlotHome(this.item);
    },
    isBlocoTexto() {
      return ehBlocoTexto(this.item);
    },
    isConteudoHtml() {
      return ehConteudoHtml(this.item);
    },
    exibeCamposImagem() {
      return exibeCamposImagem(this.item);
    },
  },
  watch: {
    item: {
      immediate: true,
      handler() {
        this.sincronizarChaveDoTipo();
        this.normalizarConteudoTipo();
      },
    },
    "item.tipo_id"() {
      this.sincronizarChaveDoTipo();
      this.normalizarConteudoTipo();
    },
    logosTipo() {
      this.sincronizarChaveDoTipo();
      this.normalizarConteudoTipo();
    },
  },
  validators: {
    "item.descricao": (value) => Validator.value(value).required(),
    "item.ordem": (value) => Validator.value(value).required(),
    "item.tipo_id": (value) => Validator.value(value).required(),
    "item.ativo": (value) => Validator.value(value).required(),
    "item.titulo, item.conteudo_tipo": function (titulo) {
      if (tituloObrigatorio(this.item)) {
        return Validator.value(titulo).required().maxLength(255);
      }
    },
    // As duas imagens são obrigatórias no SiteLogoRequest para bloco de imagem. Sem o
    // validador aqui, o Salvar ficava liberado e o operador só descobria pelo erro da
    // API — pior ainda ao editar conteúdo antigo, cadastrado antes da imagem mobile.
    "item.imagem, item.conteudo_tipo": function (imagem) {
      if (imagensObrigatorias(this.item)) {
        return Validator.value(imagem).required("A imagem desktop é obrigatória.");
      }
    },
    "item.imagem_mobile, item.conteudo_tipo": function (imagemMobile) {
      if (imagensObrigatorias(this.item)) {
        return Validator.value(imagemMobile).required("A imagem mobile é obrigatória.");
      }
    },
  },
  methods: {
    handleSubmit() {
      this.$validate().then((success) => {
        if (success) {
          this.update();
        }
      });
    },
    sincronizarChaveDoTipo() {
      const tipoSelecionado = this.logosTipo.find(
          (logoTipo) => logoTipo.id === this.item.tipo_id
      );
      if (tipoSelecionado) {
        this.$set(this.item, "chave", tipoSelecionado.chave);
      }
    },
    normalizarConteudoTipo() {
      const normalizado = conteudoTipoNormalizado(this.item);

      if (normalizado !== this.item.conteudo_tipo) {
        this.$set(this.item, "conteudo_tipo", normalizado);
      }
    },
    resetFields() {
      this.item.imagem = null;
      this.item.imagem_mobile = null;
      this.item.conteudo = "";
    },
  },
};
</script>

<style scoped>
.section-label {
  font-size: 11px;
  font-weight: 700;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 18px 0 10px;
}

.section-label:first-of-type {
  margin-top: 0;
}

.form-label {
  font-size: 12px;
  font-weight: 500;
  color: #344054;
  margin-bottom: 3px;
  display: block;
}

.form-group {
  margin-bottom: 10px;
}

.row {
  row-gap: 4px;
}

.color-input {
  padding: 3px 5px;
  height: 35px;
  cursor: pointer;
}

.toggle-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.toggle-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #e4e7eb;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #344054;
  background: #fff;
  cursor: pointer;
  margin-bottom: 0;
  transition: all 0.15s;
}

.toggle-item:hover {
  border-color: #b0bec5;
  background: #fafbfc;
}

.toggle-item.active {
  border-color: #3a3e81;
  background: #eceaf3;
  color: #3a3e81;
}

.toggle-item input {
  accent-color: #3a3e81;
  margin: 0;
}

.modal-footer-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #fff;
}
</style>
